import { Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root'
})
export class RealestateService {
  constructor(
    private http: HttpService
  ) { }

  public getList = async () => await this.http.get(`/api/v1/realestate`)
    .then((response: any) => response.data)

  public getProperty = async (id: string) => await this.http.get(`/api/v1/realestate/${id}?by=foil`)
    .then((response: any) => response.data)

  public create = async (body: any) => await this.http.post(`/api/v1/realestate`, body)
    .then((response: any) => response)

  public update = async (id: string, body: any) => await this.http.put(`/api/v1/realestate/${id}?by=foil`, body)
    .then((response: any) => response)

  public delete = async (id: string) => await this.http.delete(`/api/v1/realestate/${id}?by=foil`)
    .then((response: any) => response.data)

  public getTypeList = async () => await this.http.get(`/api/v1/realestate/type`)
    .then((response: any) => response.data)

  public getStatusList = async () => await this.http.get(`/api/v1/realestate/status`)
    .then((response: any) => response.data)
}
